import { IMemberBenefit } from '../models/member_benefit'
import { BaseUrl } from './base_url_enum'
import Api, { IApiResponse } from './index'

type IMemberBenefitsApiResponse = {
  memberbenefits: IMemberBenefit[]
  message?: string
}

type IMemberBenefitApiResponse = {
  memberBenefit: IMemberBenefit
  message?: string
}

export const getMemberBenefits = (relationNumber: number, intermediaryRefKey: string) =>
  Api<IApiResponse<IMemberBenefitsApiResponse>>('GET', `intermediary/${intermediaryRefKey}/relations/${relationNumber}/member-benefits`, BaseUrl.Content)

export const getMemberBenefit = (id: string, relationNumber: number, intermediaryRefKey: string) =>
  Api<IApiResponse<IMemberBenefitApiResponse>>('GET', `intermediary/${intermediaryRefKey}/relations/${relationNumber}/member-benefits/${id}`, BaseUrl.Content)

export const joinCampaign = (id: string, relationNumber: number, intermediaryRefKey: string) =>
  Api<IApiResponse<IMemberBenefitApiResponse>>('POST', `intermediary/${intermediaryRefKey}/relations/${relationNumber}/member-benefits/${id}/participant`, BaseUrl.Content)

export const downloadVoucher = (id: string, relationNumber: number, intermediaryRefKey: string) =>
  Api<IApiResponse<IMemberBenefitApiResponse>>('PUT', `intermediary/${intermediaryRefKey}/relations/${relationNumber}/member-benefits/${id}`, BaseUrl.Content)

export const getDiscountCode = (id: string, relationNumber: number, intermediaryRefKey: string) =>
  Api<IApiResponse<IMemberBenefitApiResponse>>('PUT', `intermediary/${intermediaryRefKey}/relations/${relationNumber}/member-benefits/${id}/discount-code`, BaseUrl.Content)

export const vote = (id: string, voteItemId: number, relationNumber: number, intermediaryRefKey: string) =>
  Api<IApiResponse<IMemberBenefitApiResponse>>('POST', `intermediary/${intermediaryRefKey}/relations/${relationNumber}/member-benefits/${id}/vote-items/${voteItemId}/vote`, BaseUrl.Content)
